import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = ['ExternalSensors', 'Sensors'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      externalSensorsGetCollectionAsyncByqueryOptions: build.query<
        ExternalSensorsGetCollectionAsyncByqueryOptionsApiResponse,
        ExternalSensorsGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/ExternalSensors`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['ExternalSensors'],
      }),
      externalSensorsPostAsyncBycreateExternalSensorDto: build.mutation<
        ExternalSensorsPostAsyncBycreateExternalSensorDtoApiResponse,
        ExternalSensorsPostAsyncBycreateExternalSensorDtoApiArg
      >({
        query: (queryArg) => ({
          url: `/ExternalSensors`,
          method: 'POST',
          body: queryArg.createExternalSensorDto,
        }),
        invalidatesTags: ['ExternalSensors'],
      }),
      externalSensorsGetAsyncByid: build.query<
        ExternalSensorsGetAsyncByidApiResponse,
        ExternalSensorsGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/ExternalSensors/${queryArg.id}` }),
        providesTags: ['ExternalSensors'],
      }),
      externalSensorsDeleteAsyncByid: build.mutation<
        ExternalSensorsDeleteAsyncByidApiResponse,
        ExternalSensorsDeleteAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/ExternalSensors/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ExternalSensors'],
      }),
      externalSensorsPatchAsyncByideditExternalSensorDto: build.mutation<
        ExternalSensorsPatchAsyncByideditExternalSensorDtoApiResponse,
        ExternalSensorsPatchAsyncByideditExternalSensorDtoApiArg
      >({
        query: (queryArg) => ({
          url: `/ExternalSensors/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.editExternalSensorDto,
        }),
        invalidatesTags: ['ExternalSensors'],
      }),
      externalSensorsPostScanForWmBusMetersByaccountId: build.mutation<
        ExternalSensorsPostScanForWmBusMetersByaccountIdApiResponse,
        ExternalSensorsPostScanForWmBusMetersByaccountIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ExternalSensors/ScanForWmBusMeters`,
          method: 'POST',
          params: {
            accountId: queryArg.accountId,
          },
        }),
        invalidatesTags: ['ExternalSensors'],
      }),
      externalSensorsPostScanForWmBusMetersByGatewayIdBygatewayId:
        build.mutation<
          ExternalSensorsPostScanForWmBusMetersByGatewayIdBygatewayIdApiResponse,
          ExternalSensorsPostScanForWmBusMetersByGatewayIdBygatewayIdApiArg
        >({
          query: (queryArg) => ({
            url: `/ExternalSensors/ScanForWmBusMetersByGatewayId`,
            method: 'POST',
            params: {
              gatewayId: queryArg.gatewayId,
            },
          }),
          invalidatesTags: ['ExternalSensors'],
        }),
      externalSensorsGetWmBusScanResultsAsyncByqueryOptions: build.query<
        ExternalSensorsGetWmBusScanResultsAsyncByqueryOptionsApiResponse,
        ExternalSensorsGetWmBusScanResultsAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/ExternalSensors/WmBusScanResults`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            GatewayId: queryArg.gatewayId,
            'Gateway.Account.AccountId': queryArg['Gateway.Account.AccountId'],
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['ExternalSensors'],
      }),
      externalSensorsPostIgnoreWmBusScanResultByguid: build.mutation<
        ExternalSensorsPostIgnoreWmBusScanResultByguidApiResponse,
        ExternalSensorsPostIgnoreWmBusScanResultByguidApiArg
      >({
        query: (queryArg) => ({
          url: `/ExternalSensors/IgnoreWmBusScanResult/${queryArg.guid}`,
          method: 'POST',
        }),
        invalidatesTags: ['ExternalSensors'],
      }),
      externalSensorsPostIgnoreWmBusScanResultBySerialByserial: build.mutation<
        ExternalSensorsPostIgnoreWmBusScanResultBySerialByserialApiResponse,
        ExternalSensorsPostIgnoreWmBusScanResultBySerialByserialApiArg
      >({
        query: (queryArg) => ({
          url: `/ExternalSensors/IgnoreWmBusScanResultBySerial/${queryArg.serial}`,
          method: 'POST',
        }),
        invalidatesTags: ['ExternalSensors'],
      }),
      sensorsGetCollectionAsyncByqueryOptions: build.query<
        SensorsGetCollectionAsyncByqueryOptionsApiResponse,
        SensorsGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Sensors'],
      }),
      sensorsGetRegistrableSensorsCollectionAsyncByaccountIdqueryOptions:
        build.query<
          SensorsGetRegistrableSensorsCollectionAsyncByaccountIdqueryOptionsApiResponse,
          SensorsGetRegistrableSensorsCollectionAsyncByaccountIdqueryOptionsApiArg
        >({
          query: (queryArg) => ({
            url: `/Sensors/AccountRegistrable/${queryArg.accountId}`,
            params: {
              orderby: queryArg.orderby,
              orderbydesc: queryArg.orderbydesc,
              top: queryArg.top,
              skip: queryArg.skip,
            },
          }),
          providesTags: ['Sensors'],
        }),
      sensorsGetAsyncByid: build.query<
        SensorsGetAsyncByidApiResponse,
        SensorsGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/Sensors/${queryArg.id}` }),
        providesTags: ['Sensors'],
      }),
      sensorsDeleteAsyncByid: build.mutation<
        SensorsDeleteAsyncByidApiResponse,
        SensorsDeleteAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Sensors'],
      }),
      sensorsPatchAsyncByideditSensorDto: build.mutation<
        SensorsPatchAsyncByideditSensorDtoApiResponse,
        SensorsPatchAsyncByideditSensorDtoApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.editSensorDto,
        }),
        invalidatesTags: ['Sensors'],
      }),
      sensorsGetSensorConnectionInfoAsyncByidqueryOptions: build.query<
        SensorsGetSensorConnectionInfoAsyncByidqueryOptionsApiResponse,
        SensorsGetSensorConnectionInfoAsyncByidqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors/${queryArg.id}/ConnectionInfo`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            Timestamp: queryArg.timestamp,
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Sensors'],
      }),
      sensorsCalibrateLevel1Byid: build.mutation<
        SensorsCalibrateLevel1ByidApiResponse,
        SensorsCalibrateLevel1ByidApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors/${queryArg.id}/Calibrate/Level1`,
          method: 'POST',
        }),
        invalidatesTags: ['Sensors'],
      }),
      sensorsCalibrateLevel2Byiddto: build.mutation<
        SensorsCalibrateLevel2ByiddtoApiResponse,
        SensorsCalibrateLevel2ByiddtoApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors/${queryArg.id}/Calibrate/Level2`,
          method: 'POST',
          body: queryArg.calibrateLevel2Dto,
        }),
        invalidatesTags: ['Sensors'],
      }),
      sensorsGetPowerDisaggregationsAsyncByqueryOptions: build.query<
        SensorsGetPowerDisaggregationsAsyncByqueryOptionsApiResponse,
        SensorsGetPowerDisaggregationsAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors/Calibrate/PowerDisaggregation`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            HasSubmeterWithStatus: queryArg.hasSubmeterWithStatus,
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Sensors'],
      }),
      sensorsPostPowerDisaggregationAsyncBydto: build.mutation<
        SensorsPostPowerDisaggregationAsyncBydtoApiResponse,
        SensorsPostPowerDisaggregationAsyncBydtoApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors/Calibrate/PowerDisaggregation`,
          method: 'POST',
          body: queryArg.createPowerDisaggregationDto,
        }),
        invalidatesTags: ['Sensors'],
      }),
      sensorsGetPowerDisaggregationsByIdAsyncByid: build.query<
        SensorsGetPowerDisaggregationsByIdAsyncByidApiResponse,
        SensorsGetPowerDisaggregationsByIdAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors/Calibrate/PowerDisaggregation/${queryArg.id}`,
        }),
        providesTags: ['Sensors'],
      }),
      sensorsPutAsyncByiddto: build.mutation<
        SensorsPutAsyncByiddtoApiResponse,
        SensorsPutAsyncByiddtoApiArg
      >({
        query: (queryArg) => ({
          url: `/Sensors/Calibrate/PowerDisaggregation/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.editPowerDisaggregationDto,
        }),
        invalidatesTags: ['Sensors'],
      }),
      sensorsStartPowerDisaggregationCalibrationByidsubMeterIdFilter:
        build.mutation<
          SensorsStartPowerDisaggregationCalibrationByidsubMeterIdFilterApiResponse,
          SensorsStartPowerDisaggregationCalibrationByidsubMeterIdFilterApiArg
        >({
          query: (queryArg) => ({
            url: `/Sensors/Calibrate/PowerDisaggregation/${queryArg.id}/Start`,
            method: 'POST',
            body: queryArg.startPowerDisaggregationDto,
          }),
          invalidatesTags: ['Sensors'],
        }),
      sensorsUpdatePowerDisaggregationCalibrationStatusByidsubMeterStatusDtos:
        build.mutation<
          SensorsUpdatePowerDisaggregationCalibrationStatusByidsubMeterStatusDtosApiResponse,
          SensorsUpdatePowerDisaggregationCalibrationStatusByidsubMeterStatusDtosApiArg
        >({
          query: (queryArg) => ({
            url: `/Sensors/Calibrate/PowerDisaggregation/${queryArg.id}/Status`,
            method: 'PUT',
            body: queryArg.body,
          }),
          invalidatesTags: ['Sensors'],
        }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type ExternalSensorsGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 External sensor entities response */ ReadExternalSensorDto[];
export type ExternalSensorsGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>ExternalSensorId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>ExternalSensorId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type ExternalSensorsPostAsyncBycreateExternalSensorDtoApiResponse =
  /** status 201 Created */ object;
export type ExternalSensorsPostAsyncBycreateExternalSensorDtoApiArg = {
  /** The entity to create */
  createExternalSensorDto: CreateExternalSensorDto;
};
export type ExternalSensorsGetAsyncByidApiResponse =
  /** status 200 ExternalSensor entity response */ ReadExternalSensorDto;
export type ExternalSensorsGetAsyncByidApiArg = {
  /** Id of entity to retrieve */
  id: number;
};
export type ExternalSensorsDeleteAsyncByidApiResponse =
  /** status 204 No content */ object;
export type ExternalSensorsDeleteAsyncByidApiArg = {
  /** Id of entity to delete */
  id: number;
};
export type ExternalSensorsPatchAsyncByideditExternalSensorDtoApiResponse =
  /** status 204 No content */ object;
export type ExternalSensorsPatchAsyncByideditExternalSensorDtoApiArg = {
  /** The id of the ExternalSensor */
  id: number;
  /** The changes to apply */
  editExternalSensorDto: EditExternalSensorDto;
};
export type ExternalSensorsPostScanForWmBusMetersByaccountIdApiResponse =
  /** status 202 Accepted */ object;
export type ExternalSensorsPostScanForWmBusMetersByaccountIdApiArg = {
  /** Id of account to scan for */
  accountId: number;
};
export type ExternalSensorsPostScanForWmBusMetersByGatewayIdBygatewayIdApiResponse =
  /** status 204 No content */ object;
export type ExternalSensorsPostScanForWmBusMetersByGatewayIdBygatewayIdApiArg =
  {
    /** Id of gateway to scan for */
    gatewayId: number;
  };
export type ExternalSensorsGetWmBusScanResultsAsyncByqueryOptionsApiResponse =
  /** status 200 WmBus scan result entities response */ DeviceScanResultDto[];
export type ExternalSensorsGetWmBusScanResultsAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>Timestamp</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>Timestamp</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by GatewayId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  gatewayId?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Gateway.Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Gateway.Account.AccountId'?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type ExternalSensorsPostIgnoreWmBusScanResultByguidApiResponse =
  /** status 204 No content */ object;
export type ExternalSensorsPostIgnoreWmBusScanResultByguidApiArg = {
  /** GUID of the scan result to ignore */
  guid: string;
};
export type ExternalSensorsPostIgnoreWmBusScanResultBySerialByserialApiResponse =
  /** status 204 No content */ object;
export type ExternalSensorsPostIgnoreWmBusScanResultBySerialByserialApiArg = {
  /** Serial of the scan result to ignore */
  serial: number;
};
export type SensorsGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 Sensor entities response */ ReadSensorDto[];
export type SensorsGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>SensorId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>SensorId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type SensorsGetRegistrableSensorsCollectionAsyncByaccountIdqueryOptionsApiResponse =
  /** status 200 Sensor entities response */ ReadRegistrableSensorDto[];
export type SensorsGetRegistrableSensorsCollectionAsyncByaccountIdqueryOptionsApiArg =
  {
    /** Lookup registrable sensors for this accountId */
    accountId: number;
    /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>SensorId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
    orderby?: string;
    /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>SensorId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
    orderbydesc?: string;
    /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
    top?: number;
    /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
    skip?: number;
  };
export type SensorsGetAsyncByidApiResponse =
  /** status 200 Alarm entity response */ ReadSensorDto;
export type SensorsGetAsyncByidApiArg = {
  /** The id of the sensor */
  id: number;
};
export type SensorsDeleteAsyncByidApiResponse =
  /** status 204 No content */ object;
export type SensorsDeleteAsyncByidApiArg = {
  /** The id of the sensor */
  id: number;
};
export type SensorsPatchAsyncByideditSensorDtoApiResponse =
  /** status 204 No content */ object;
export type SensorsPatchAsyncByideditSensorDtoApiArg = {
  /** The id of the sensor */
  id: number;
  /** The DataInterval to apply */
  editSensorDto: EditSensorDto;
};
export type SensorsGetSensorConnectionInfoAsyncByidqueryOptionsApiResponse =
  /** status 200 Sensor entities response */ ReadSensorSignalStrengthDto[];
export type SensorsGetSensorConnectionInfoAsyncByidqueryOptionsApiArg = {
  /** The id of the sensor */
  id: number;
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>Timestamp</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>Timestamp</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Timestamp using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(datetime)</code>
    Greater than or equal:
    <code>ge(datetime)</code>
    Greater than:
    <code>gt(datetime)</code>
    Less than or equal:
    <code>le(datetime)</code>
    Less than:
    <code>lt(datetime)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(2021-01-01T16:00:00.0000000+02:00)</code>
    Greater than or equal:
    <code>ge(2021-01-01T16:00:00.0000000+02:00)</code>
    Greater than:
    <code>gt(2021-01-01T16:00:00.0000000+02:00)</code>
    Less than or equal:
    <code>le(2021-01-02T16:00:00.0000000+02:00)</code>
    Less than:
    <code>lt(2021-01-02T16:00:00.0000000+02:00)</code></pre></div> */
  timestamp: string[];
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type SensorsCalibrateLevel1ByidApiResponse =
  /** status 204 No content */ object;
export type SensorsCalibrateLevel1ByidApiArg = {
  /** The id of the sensor */
  id: number;
};
export type SensorsCalibrateLevel2ByiddtoApiResponse =
  /** status 204 No content */ object;
export type SensorsCalibrateLevel2ByiddtoApiArg = {
  /** The id of the sensor */
  id: number;
  /** The changes to apply */
  calibrateLevel2Dto: CalibrateLevel2Dto;
};
export type SensorsGetPowerDisaggregationsAsyncByqueryOptionsApiResponse =
  /** status 200 PowerDisaggregation entity response */ ReadPowerDisaggregationDto[];
export type SensorsGetPowerDisaggregationsAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>PowerDisaggregationId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>PowerDisaggregationId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by HasSubmeterWithStatus using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(calibrationstatus)</code></pre></div><p>hassubmeterwithstatus = ['Awaiting', 'InProgress', 'Complete', 'Failed']</p><p>Examples:</p><div><pre>Equal to:
    <code>eq(Awaiting)</code></pre></div> */
  hasSubmeterWithStatus?: string[];
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type SensorsPostPowerDisaggregationAsyncBydtoApiResponse =
  /** status 204 No content */ object;
export type SensorsPostPowerDisaggregationAsyncBydtoApiArg = {
  /** The changes to apply */
  createPowerDisaggregationDto: CreatePowerDisaggregationDto;
};
export type SensorsGetPowerDisaggregationsByIdAsyncByidApiResponse =
  /** status 200 PowerDisaggregation entity response */ object;
export type SensorsGetPowerDisaggregationsByIdAsyncByidApiArg = {
  /** The id of the PowerDisaggregation */
  id: number;
};
export type SensorsPutAsyncByiddtoApiResponse =
  /** status 204 No content */ object;
export type SensorsPutAsyncByiddtoApiArg = {
  /** The id of the PowerDisaggregation */
  id: number;
  /** The changes to apply */
  editPowerDisaggregationDto: EditPowerDisaggregationDto;
};
export type SensorsStartPowerDisaggregationCalibrationByidsubMeterIdFilterApiResponse =
  /** status 204 No content */ object;
export type SensorsStartPowerDisaggregationCalibrationByidsubMeterIdFilterApiArg =
  {
    /** The id of the PowerDisaggregation */
    id: number;
    /** Optional filter of which submeters to start. If this is not supplied, all associated submeters will be started */
    startPowerDisaggregationDto: StartPowerDisaggregationDto;
  };
export type SensorsUpdatePowerDisaggregationCalibrationStatusByidsubMeterStatusDtosApiResponse =
  /** status 204 No content */ object;
export type SensorsUpdatePowerDisaggregationCalibrationStatusByidsubMeterStatusDtosApiArg =
  {
    /** PowerDisaggregation Id */
    id: number;
    body: EditPowerDisaggregationSubMeterStatusDto[];
  };
export type ManufacturerNoRefsDto = {
  ManufacturerId: number;
  Name?: string;
  EncryptionKeyRequired: boolean;
};
export type ReadExternalSensorChannelDto = {
  ExternalSensorDeviceId: number;
  DataType?: string;
  ChannelNumber: number;
  ChannelName?: string;
};
export type ReadExternalSensorDeviceDto = {
  Key?: string;
  Name?: string;
  Manufacturer?: ManufacturerNoRefsDto;
  Channels?: ReadExternalSensorChannelDto[];
  ExternalSensorType: 'Remoni' | 'WmBus';
  MeterType?: string;
  ExternalSensorDeviceId: number;
};
export type AccountNoRefsDto = {
  AccountId: number;
  Name: string;
  Address: string;
  BillingAddress?: string;
};
export type GatewayActivitiesNoRefsDto = {
  SensorId: number;
  GatewayId: number;
  SensorType:
    | 'AccessPoint'
    | 'PowerMoniSpot'
    | 'PowerMoniMain'
    | 'FlowMoniSpot'
    | 'HeatMoniSpot'
    | 'TempMoniSpot'
    | 'AnalogMoniSpot'
    | 'FlowMoniVolume'
    | 'TempMoniDC'
    | 'FlowMoniEnergy'
    | 'AnalogMoniActive'
    | 'GatewaySensor';
  LastActivity: string;
  ReceivedSignalStrengthIndication?: number;
  LinkQualityIndication?: number;
};
export type GatewayExternalActivitiesNoRefsDto = {
  ExternalSensorId: number;
  GatewayId: number;
  LastActivity: string;
  ReceivedSignalStrengthIndication?: number;
};
export type GatewayConnectionStatus = {
  LatestDongleTimestamp?: string;
  LatestDongleSignalLevel?: number;
  LatestDongleImei?: string;
  LatestDongleWorkmode?: string;
  LatestDongleDeviceName?: string;
  LatestWifiTimestamp?: string;
  LatestWifiSignalLevel?: number;
  LatestWifiIpAddress?: string;
  LatestWifiMacAddress?: string;
  LatestWifiSsid?: string;
  LatestWifiChannel?: number;
  LatestWifiFrequency?: number;
  LatestMobileTimestamp?: string;
  LatestMobileImsi?: string;
  LatestMobileApn?: string;
  LatestMobileRssi?: number;
  LatestMobileRsrq?: number;
  LatestMobileRsrp?: number;
  LatestMobileCinr?: number;
  LatestEthernetTimestamp?: string;
  LatestEthernetIpAddress?: string;
  LatestEthernetMac?: string;
};
export type ReadGatewayDto = {
  GatewayId: number;
  Name?: string;
  Description?: string;
  ImageHash?: number;
  Account?: AccountNoRefsDto;
  LastActivity?: string;
  RegistrationDate?: string;
  SensorActivities?: GatewayActivitiesNoRefsDto[];
  ExternalSensorActivities?: GatewayExternalActivitiesNoRefsDto[];
  Latitude?: number;
  Longitude?: number;
  LocationAccuracy?: number;
  CurrentApplicationFirmware?: string;
  CurrentCommonFirmware?: string;
  ReportedApplicationFirmware?: string;
  Variant: 'Repeater' | 'Gateway';
  Online?: boolean;
  ConnectionStatus?: GatewayConnectionStatus;
  ApMode?: 'Normal' | 'WmBus';
  TargetApMode?: 'Normal' | 'WmBus';
  GatewayVersion?: string;
  HWRevision?: string;
  SWRevision?: string;
  OptoEye: boolean;
  Modem: boolean;
  PCT: boolean;
};
export type UnitNoRefsDto = {
  UnitId: number;
  Name: string;
  Description?: string;
  Latitude?: number;
  Longitude?: number;
  GpsAccuracy?: number;
};
export type ReadExternalSensorUnitSensorDto = {
  UnitSensorId: number;
  ChannelNumber: number;
  UnitTypeInputId: number;
  Unit: UnitNoRefsDto;
};
export type ExternalSensorActivitiesNoRefsDto = {
  ExternalSensorId: number;
  GatewayId: number;
  LastActivity: string;
  ReceivedSignalStrengthIndication?: number;
};
export type ReadWmBusDeviceDto = {
  State?: 'Unconfirmed' | 'Ok';
  EncryptionKey?: string;
  RegisteredToGateway?: boolean;
  LastConfigChange?: string;
};
export type ReadExternalSensorDto = {
  Device?: ReadExternalSensorDeviceDto;
  Gateway?: ReadGatewayDto;
  ExternalSensorId: number;
  Name?: string;
  AccountId?: number;
  UnitSensors?: ReadExternalSensorUnitSensorDto[];
  DeviceId?: string;
  GatewayId?: number;
  ExternalSensorActivities?: ExternalSensorActivitiesNoRefsDto[];
  WmBusDevice?: ReadWmBusDeviceDto;
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export type AccountIdDto = {
  AccountId: number;
};
export type CreateExternalSensorDto = {
  Name: string;
  Account: AccountIdDto;
  DeviceId: string;
  EncryptionKey?: string;
  ManufacturerDeviceKey?: string;
  GatewayId?: number;
};
export type ErrorResult4 = ErrorResult;
export type EditExternalSensorDto = {
  Name?: string;
  DeviceId?: string;
  WmBusDevice?: ReadWmBusDeviceDto;
};
export type DeviceScanResultDto = {
  Timestamp: string;
  GatewayId: number;
  Manufacturer: number;
  Serial?: string;
  Type: number;
  ManufacturerName?: string;
  TypeName?: string;
  Ignore?: boolean;
  Guid?: string;
  ExternalSensorId?: number;
};
export type SensorActivitiesNoRefsDto = {
  SensorId: number;
  GatewayId?: number;
  LastActivity: string;
  ReceivedSignalStrengthIndication?: number;
  LinkQualityIndication?: number;
};
export type ReadSensorUnitSensorDto = {
  UnitSensorId: number;
  ChannelNumber: number;
  UnitTypeInputId: number;
  Unit: UnitNoRefsDto;
};
export type SensorChannelParameterDto = {
  SensorId: number;
  ChannelNumber: number;
  AnalogTargetDataType?: string;
  AnalogFactor?: number;
  AnalogOffset?: number;
};
export type ReadSensorDto = {
  SensorId: number;
  DataLastRecorded?: string;
  IsConfigured: boolean;
  SensorType:
    | 'AccessPoint'
    | 'PowerMoniSpot'
    | 'PowerMoniMain'
    | 'FlowMoniSpot'
    | 'HeatMoniSpot'
    | 'TempMoniSpot'
    | 'AnalogMoniSpot'
    | 'FlowMoniVolume'
    | 'TempMoniDC'
    | 'FlowMoniEnergy'
    | 'AnalogMoniActive'
    | 'GatewaySensor';
  ChannelCount: number;
  DataTypes?: string[];
  Account?: AccountNoRefsDto;
  LatestSensorActivities?: SensorActivitiesNoRefsDto[];
  UnitSensors?: ReadSensorUnitSensorDto[];
  DataInterval?:
    | 'Minute'
    | 'Minutes5'
    | 'Seconds20Boost'
    | 'Seconds3Boost'
    | 'Minutes30'
    | 'Inactive'
    | 'Second'
    | 'Custom';
  TargetDataInterval?:
    | 'Minute'
    | 'Minutes5'
    | 'Seconds20Boost'
    | 'Seconds3Boost'
    | 'Minutes30'
    | 'Inactive'
    | 'Second'
    | 'Custom';
  TempTransmitInterval?: number;
  TempSampleInterval?: number;
  TargetTempTransmitInterval?: number;
  TargetTempSampleInterval?: number;
  CalibrationConstant?: number;
  CalibrationType?:
    | 'Level1'
    | 'Level2ApparentPower'
    | 'Level2Current'
    | 'PowerDisaggregation';
  CurrentApplicationFirmware?: string;
  CurrentCommonFirmware?: string;
  ReportedApplicationFirmware?: string;
  SensorChannelParameters?: SensorChannelParameterDto[];
  MotorMonitoringEnabled: boolean;
  VolumeConstant?: number;
  TargetVolumeConstant?: number;
  FlowGap?: number;
  TargetFlowGap?: number;
  FlowPipeDiameter?: number;
  PairedGatewayId?: number;
  EnforceFlowParams: boolean;
  LatestDataFlowSignalAmplitudeValue?: number;
  LatestDataFlowSignalAmplitudeTimestamp?: string;
};
export type ReadRegistrableSensorDto = {
  SensorId: number;
  SensorType:
    | 'AccessPoint'
    | 'PowerMoniSpot'
    | 'PowerMoniMain'
    | 'FlowMoniSpot'
    | 'HeatMoniSpot'
    | 'TempMoniSpot'
    | 'AnalogMoniSpot'
    | 'FlowMoniVolume'
    | 'TempMoniDC'
    | 'FlowMoniEnergy'
    | 'AnalogMoniActive'
    | 'GatewaySensor';
  SensorChannelParameters?: SensorChannelParameterDto[];
  CalibrationConstant?: number;
  CalibrationType?:
    | 'Level1'
    | 'Level2ApparentPower'
    | 'Level2Current'
    | 'PowerDisaggregation';
  UnitSensors?: ReadSensorUnitSensorDto[];
  MotorMonitoringEnabled: boolean;
  Account?: AccountIdDto;
};
export type EditDataConversionParametersDto = {
  ChannelNumber?: number;
  TargetDataType?: string;
  ConversionFactor?: number;
  ConversionOffset?: number;
};
export type EditSensorDto = {
  DataInterval?:
    | 'Minute'
    | 'Minutes5'
    | 'Seconds20Boost'
    | 'Seconds3Boost'
    | 'Minutes30'
    | 'Second'
    | 'Custom';
  DataConversionParameters?: EditDataConversionParametersDto[];
  VolumeConstant?: number;
  FlowPipeDiameter?: number;
};
export type ReadSensorSignalStrengthDto = {
  Timestamp: string;
  RSSI: number;
};
export type CalibrateLevel2Dto = {
  CalibrationConstant: number;
  CalibrationType: 'ApparentPower' | 'Current';
  DataCatchUpStart?: string;
};
export type ReadPowerDisaggregationSubMeterDto = {
  SensorId: number;
  Status: 'Awaiting' | 'InProgress' | 'Complete' | 'Failed';
  FailureReason?: string;
  CalibrationFactor?: number;
  CalibrationType:
    | 'Level1'
    | 'Level2ApparentPower'
    | 'Level2Current'
    | 'PowerDisaggregation';
  CalibrationCoilNumber?: number;
  UnitId: number;
  UnitTypeInputId: number;
  DataTypes?: string[];
  StartTime?: string;
};
export type ReadPhasesDto = {
  ChannelNo: number;
  UnitId: number;
  UnitTypeInputId: number;
};
export type ReadPowerDisaggregationMainMeterDto = {
  MainMeterId: number;
  Phases?: {
    [key: string]: ReadPhasesDto;
  };
};
export type ReadPowerDisaggregationDto = {
  PowerDisaggregationId: number;
  AccountId: number;
  DisplayName?: string;
  PowerDisaggregationStarted?: string;
  SubMeters?: ReadPowerDisaggregationSubMeterDto[];
  MainMeters?: ReadPowerDisaggregationMainMeterDto[];
};
export type CreateEditPowerDisaggregationSubMeterDto = {
  SensorId: number;
};
export type CreateEditPhasesDto = {
  ChannelNo: number;
};
export type PowerDisaggregationMainMeterDto = {
  MainMeterId: number;
  Phases?: {
    [key: string]: CreateEditPhasesDto;
  };
};
export type CreatePowerDisaggregationDto = {
  AccountId: number;
  SubMeters?: CreateEditPowerDisaggregationSubMeterDto[];
  MainMeters?: PowerDisaggregationMainMeterDto[];
  DisplayName?: string;
};
export type EditPowerDisaggregationDto = {
  DisplayName?: string;
  SubMeters?: CreateEditPowerDisaggregationSubMeterDto[];
  MainMeters?: PowerDisaggregationMainMeterDto[];
};
export type StartPowerDisaggregationDto = {
  SubMeterIdFilter?: number[];
};
export type EditPowerDisaggregationSubMeterStatusDto = {
  SensorId: number;
  Status: 'Awaiting' | 'InProgress' | 'Complete' | 'Failed';
  CalibrationFactor?: number;
  CalibrationCoilNumber: number;
  PowerDisaggregationFailureReason?: string;
};
export const {
  useExternalSensorsGetCollectionAsyncByqueryOptionsQuery,
  useLazyExternalSensorsGetCollectionAsyncByqueryOptionsQuery,
  useExternalSensorsPostAsyncBycreateExternalSensorDtoMutation,
  useExternalSensorsGetAsyncByidQuery,
  useLazyExternalSensorsGetAsyncByidQuery,
  useExternalSensorsDeleteAsyncByidMutation,
  useExternalSensorsPatchAsyncByideditExternalSensorDtoMutation,
  useExternalSensorsPostScanForWmBusMetersByaccountIdMutation,
  useExternalSensorsPostScanForWmBusMetersByGatewayIdBygatewayIdMutation,
  useExternalSensorsGetWmBusScanResultsAsyncByqueryOptionsQuery,
  useLazyExternalSensorsGetWmBusScanResultsAsyncByqueryOptionsQuery,
  useExternalSensorsPostIgnoreWmBusScanResultByguidMutation,
  useExternalSensorsPostIgnoreWmBusScanResultBySerialByserialMutation,
  useSensorsGetCollectionAsyncByqueryOptionsQuery,
  useLazySensorsGetCollectionAsyncByqueryOptionsQuery,
  useSensorsGetRegistrableSensorsCollectionAsyncByaccountIdqueryOptionsQuery,
  useLazySensorsGetRegistrableSensorsCollectionAsyncByaccountIdqueryOptionsQuery,
  useSensorsGetAsyncByidQuery,
  useLazySensorsGetAsyncByidQuery,
  useSensorsDeleteAsyncByidMutation,
  useSensorsPatchAsyncByideditSensorDtoMutation,
  useSensorsGetSensorConnectionInfoAsyncByidqueryOptionsQuery,
  useLazySensorsGetSensorConnectionInfoAsyncByidqueryOptionsQuery,
  useSensorsCalibrateLevel1ByidMutation,
  useSensorsCalibrateLevel2ByiddtoMutation,
  useSensorsGetPowerDisaggregationsAsyncByqueryOptionsQuery,
  useLazySensorsGetPowerDisaggregationsAsyncByqueryOptionsQuery,
  useSensorsPostPowerDisaggregationAsyncBydtoMutation,
  useSensorsGetPowerDisaggregationsByIdAsyncByidQuery,
  useLazySensorsGetPowerDisaggregationsByIdAsyncByidQuery,
  useSensorsPutAsyncByiddtoMutation,
  useSensorsStartPowerDisaggregationCalibrationByidsubMeterIdFilterMutation,
  useSensorsUpdatePowerDisaggregationCalibrationStatusByidsubMeterStatusDtosMutation,
} = injectedRtkApi;
